// extracted by mini-css-extract-plugin
export default {"all-services":"all-services_all-services__iOPLv"};